module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_62.d469c4f0.png";